import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './errors'

/**
 * Console data is server state; phone data is IndexedDB (src/offline) — React Query is for
 * the online side. Retries only for transient failures; 4xx are final.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 10 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && !error.isTransient) return false
          return failureCount < 2
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
      mutations: {
        retry: false,
      },
    },
  })
}

/** Query key factory convention: ['area', 'resource', params]. Add per-feature keys next to the feature. */
export const queryKeys = {
  me: ['auth', 'me'] as const,
  appConfig: ['app-config'] as const,
}
